<div class="header">
  <strong>CRIADO POR</strong>
  <strong>PERÍODO</strong>
  <strong>AÇÕES</strong>
</div>
